
import React, { useState, useEffect } from 'react';
import axios from 'axios';

function MonthPolicy({ data: propData, monthName, year }) {
  const [policyData, setPolicyData] = useState(propData || {});
  const [loading, setLoading] = useState(!propData);
  const [error, setError] = useState(null); 

  useEffect(() => {
    if (!propData) {
      fetchPolicyData();
    } else {
      setPolicyData(propData);
      setLoading(false);
      setError(null);
    }
  }, [propData]);

  const fetchPolicyData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/distribution/month_policy`,
        { timeout: 10000 } 
      );
      setPolicyData(response.data);
    } catch (error) {
      console.error('Error fetching policy data:', error);
      setError("Invalid Exception"); 
      setPolicyData({}); 
    } finally {
      setLoading(false); 
    }
  };

  if (loading) {
    return <div align="center" id="loadingR" style={{display: 'block'}}><img src="images/progress.gif" alt="Loading" /></div>; 
  }
  if (error) {
    return <div className="response" style={{color: 'red'}}>{error}</div>;
  }
  if (Object.keys(policyData).length === 0) {
    return (
      <table width="50%" align="center" border="1">
        <tbody>
          <tr className="tableheader" align="center"><td colSpan="2">No policy data available</td></tr>
        </tbody>
      </table>
    );
  }

  return (
    <div align="center">
      <table width="50%" align="center" border="1">
        <thead>
          <tr className="tableheader" align="center">
            <td colSpan="2">
              Price Chart for <font style={{ color: "orange" }}>
                {monthName} '{year}
              </font>
            </td>
          </tr>
          <tr className="tableheader" align="center">
            <td>Distribution</td>
            <td>Rate<br/>(Rs) </td>
          </tr>
        </thead>
        <tbody>

          {Object.entries(policyData).map(([schemeName, commodities]) => {
        
            return (
              <React.Fragment key={schemeName}>
                <tr className="tableheader">
                  <td colSpan="2"><div align="center">{schemeName}</div></td>
                </tr>
                <tr className="tableheader" align="center">
                  <td>Commodity</td>
                  <td>Per<br/>Kg/Lt</td>
                </tr>
                {commodities.map((commodity, idx) => {
                 
                  let displayPrice;
                  const retailPrice = commodity.retailPrice || '';
                  const commEntitle = commodity.commEntitle || '';
                  if (retailPrice.toLowerCase() === '0' && commEntitle.toLowerCase() === '0') {
                    displayPrice = "-NA-";
                  } else if (retailPrice.toLowerCase() === '0') {
                    displayPrice = "Free";
                  } else {
                    displayPrice = parseFloat(retailPrice || 0).toFixed(1);  
                  }
                  return (
                    <tr key={idx}>
                      <td>{commodity.commodityName}</td>
                      <td align="center">{displayPrice}</td>
                    </tr>
                  );
                })}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default MonthPolicy;
